import { Component, Input, Output, EventEmitter } from "@angular/core";
import { PaginaResultadoBusca } from "../leitor-content-panelbuscaavancada/leitor-content-panelbuscaavancada.component";

@Component({
  selector: "app-paginador",
  templateUrl: "./paginador.component.html",
  styleUrls: ["./paginador.component.scss"],
})
export class PaginadorComponent {
  @Input() textoCentralPaginador: string;
  @Input() paginas: PaginaResultadoBusca[];
  @Input() indexAtual: number;

  @Output() retroceder = new EventEmitter<void>();
  @Output() avancar = new EventEmitter<void>();
  @Output() irPara = new EventEmitter<PaginaResultadoBusca>();

  constructor() {
    this.indexAtual = 0;
  }

  retrocederClick() {
    if (this.indexAtual === 0) {
      this.indexAtual = this.paginas.length - 1;
    } else {
      this.indexAtual--;
    }

    this.retroceder.emit();
  }

  avancarClick() {
    if (this.indexAtual === this.paginas.length - 1) {
      this.indexAtual = 0;
    } else {
      this.indexAtual++;
    }

    this.avancar.emit();
  }

  irParaClick(event: Event, pagina: PaginaResultadoBusca) {
    // event.stopPropagation();
    // event.preventDefault();

    const indexPaginaIr = this.paginas.findIndex(
      (p) => p.idLei === pagina.idLei
    );
    if (this.indexAtual === indexPaginaIr) {
      return;
    }

    this.indexAtual = indexPaginaIr;
    this.irPara.emit(pagina);
  }
}
